import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';

export class UtilityButtonDefault extends React.Component {
  render() {
    return (
      <div className="utility-buttons">
        <p>
          <Button variant="outline-secondary" onClick={this.props.onClick}>
            <FormattedMessage {...this.props.buttonName } />
          </Button>
        </p>
      </div>
    );
  }
}

UtilityButtonDefault.propTypes = {
  buttonName: PropTypes.object,
  onClick: PropTypes.func,
};
